<h1 mat-dialog-title class="mt-0">
  {{ data.modalTitle ? data.modalTitle : "Alert" }}
</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end" class="mt-4">
  <button
    mat-stroked-button
    class="me-1" color="primary"
    (click)="dialogRef.close()"
  >
    {{ cancelButtonText }}
  </button>
  <button *ngIf="data.buttonText.ok"
    mat-raised-button color="primary"
    [disabled]="isSubmitting"
    (click)="onConfirmClick()"
  >
    {{ confirmButtonText }}
  </button>
</div>
